import { render, staticRenderFns } from "./PlayPauseButton.vue?vue&type=template&id=1ad24844&scoped=true&"
import script from "./PlayPauseButton.vue?vue&type=script&lang=js&"
export * from "./PlayPauseButton.vue?vue&type=script&lang=js&"
import style0 from "./PlayPauseButton.vue?vue&type=style&index=0&id=1ad24844&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad24844",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
